import {useMapContext} from '@/components/MindMap/index.mjs'

const bizNodeType2Type = {
    CA: 'Ca',
    CAT_DB: 'Db',
    CAT_LS: 'Ls',
    CAT_MD: 'Md',
    CAT_RULEM: 'RulemRm',
    CAT_SS: 'Ss',
    FA: 'Fa',
    OA: 'Oa',
    PA: 'Pa',
    UA: 'Ua',
}

export default (type, label) => {
    const map = useMapContext()

    const {mapStsCode, mapTypeCode, pblType} = map.data

    if (
        'SA_MAP' !== mapTypeCode ||
        'INCREMENT' === pblType ||
        'RLS' === mapStsCode
    ) {
        return null
    }

    const types = new Set(
        map.root.children.map(n => bizNodeType2Type[n.data.bizNodeType])
    )

    if (
        'Sa' !== type &&
        ! types.has(type)
    ) {
        return null
    }

    const onClick = () => map.commands.integrate(type)

    return {
        label,
        onClick,
    }
}
